export default "__VITE_ASSET__Uml82o35__"